import { FC } from 'react';
import { Box } from '@mui/material';
import { CheckCircle, HourglassEmpty, Cancel } from '@mui/icons-material';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

interface ElecNotifStatusProps {
  status: 'active' | 'requested' | 'unactive';
}

const ElectronicNotificationStatus: FC<ElecNotifStatusProps> = ({ status }) => {
  const { t } = useTranslation();
    
  const statusMap = {
    active: { label: t('common:text.electronic_notification_active'), icon: <CheckCircle fontSize="small" /> },
    requested: { label: t('common:text.electronic_notification_requested'), icon: <HourglassEmpty fontSize="small" /> },
    unactive: { label: t('common:text.electronic_notification_unactive'), icon: <Cancel fontSize="small" /> }
  };

  const { label, icon } = statusMap[status];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {icon}
      <Box component="span">{label}</Box>
    </Box>
  );
};

export default ElectronicNotificationStatus;
